import { render, staticRenderFns } from "./addHousekeepingType.vue?vue&type=template&id=7b22960b"
import script from "./addHousekeepingType.vue?vue&type=script&lang=js"
export * from "./addHousekeepingType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports